import React, { useState, useEffect, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';
import ReactLoading from 'react-loading';

import { SessionContext } from "../context/session-context";

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

const useStyles = makeStyles({
  root:{
    paddingTop:40,
    height: 'calc(100vh - 300px)'
  },
  passwordField:{
    width: 310,
  },
  actionButton:{
    color: '#FFFFFF',
    backgroundColor: '#29C548',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#E55300',
    },
    minWidth:120,
    height:32,
  },
  errorTxt:{
    color: '#ff0000',
    fontSize:12
  }


});

export default function LoginInterface(props) {

    const classes = useStyles();
    const [state, dispatch] = useContext(SessionContext);
    const [email, setEmail] = useState(''); //dev 'suiwin.hui@findmaps.co.uk'
    const [password, setPassword] = useState(''); //'FindMaps22'
    const [processing, setProcessing] = useState(false);
    const [hasError, setHasError] = useState(false);

    const [errorMsg, setErrorMsg] = useState('');
    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const handleSubmit = () => {
        setHasError(false);
        setIsLoading(true);
        setProcessing(true);
      }

      useEffect(() => {

        if (processing){
          setIsLoading(true);
          const abortController = new AbortController();
          const request = {   
            name:email,
            password:password
          };
    
          let mounted = true;
          (async () => {
            const res = await fetch(process.env.REACT_APP_FIND_API+'/find/login', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(request),
              signal: abortController.signal,
            });
            const data = await res.json();
            setProcessing(false);
            if (mounted) {
              console.log(JSON.stringify(data));
              if (data.status === "success"){
                setHasError(false);
                dispatch({
                  type: "create",
                  payload: { userid: parseInt(data.uid), aid: parseInt(data.aid), isActive: true, ident: data.ident }
                });
                
              } else {
                setErrorMsg('Invalid username or password.')
                setHasError(true);
              }
              setIsLoading(false);
              
            }
          })();
          const cleanup = () => {
             mounted = false;
             abortController.abort();
          };
          return cleanup;
        
        }
    
      }, [processing]);

      const handleSnackClose=()=>{
        setSnackOpen(false);
        props.close();
      }

    return (
      <div className={classes.root}>
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackOpen}
            autoHideDuration={6000}
            onClose={handleSnackClose}
            TransitionComponent={Slide}
            TransitionProps={{ direction: 'down' }}
        >
            <Alert onClose={handleSnackClose} severity={severity}>
              {msg}
            </Alert>
        </Snackbar>
        <Grid container>
          <Grid item xs={12}>
            <Box p={1} display="flex" justifyContent="center" >
              <Box fontWeight="fontWeightBold" fontSize={18} >To login to your account please provide your username and password.</Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box p={1} display="flex" justifyContent="center">
                <TextField type="email" name="email" error={hasError} className={classes.passwordField} label="Please enter your username" variant="outlined" size="small" margin="dense" value={email} onChange={e => setEmail(e.target.value)} required />
            </Box>
          </Grid>
          <Grid item xs={12}>
          <Box p={1} display="flex" justifyContent="center">
            <TextField type="password" name="password" error={hasError} className={classes.passwordField} label="Please enter your new password" variant="outlined" size="small" margin="dense" value={password} onChange={e => setPassword(e.target.value)} required />
          </Box>
            {hasError ? ( <Box p={1} display="flex" justifyContent="center"><Typography className={classes.errorTxt}>{errorMsg}</Typography></Box>) : ( '' )}
          </Grid>
          <Grid item xs={12}>
            <Box p={1} display="flex" justifyContent="center">
            {isLoading ? (
              <Box p={1} justifyContent="center"><ReactLoading className={classes.loadingImg} type={"bars"} color={"#E55300"} /></Box>
            ) : ( 
              <Button className={classes.actionButton} variant="contained" onClick={handleSubmit}>
                <Box fontWeight="fontWeightRegular" fontSize={14} >Login</Box>
              </Button>
            )}
            </Box>
          </Grid>
      </Grid>
      </div>
  
    );
  }